import { render, staticRenderFns } from "./ServiceDetailModal.vue?vue&type=template&id=528b4f4e&"
import script from "./ServiceDetailModal.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports